import React, { useState } from 'react';
import { Button, Currency, FlexRow, Grid, SpaceWrapper } from 'ui-toolkit';
import { AmountText } from '../AmountText';
import { escrowTableSize } from '../escrowTableSize';
import GrayLine from '../../../../shared/GrayLine';
import { SpaAddOutgoingButton } from '../SpaAddOutgoingButton';
import { ICDV3ViewItem } from '../../../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { generateDisplayLabel } from 'ui-toolkit/cdItems/data/generateDisplayLabel';

interface ICDItemRowProps {
  item: ICDV3ViewItem;
  onAddTransaction: (fieldName: string, amount: number, cdItemId: string) => void;
}

export const SpaCDItemRow: React.FC<ICDItemRowProps> = ({ item, onAddTransaction }) => {
  const displayLabel = generateDisplayLabel(item);
  const total = (item.buyer_at_closing || 0) + (item.seller_at_closing || 0);
  const [hideItem, setHideItem] = useState(false);
  const onHide = () => {
    setHideItem(true);
  };
  return (
    <>
      {!hideItem && (
        <>
          <GrayLine />
          <SpaceWrapper topSpace={'roomy'} bottomSpace={'roomy'} leftSpace={'none'} rightSpace={'none'}>
            <Grid columnWidth={escrowTableSize} alignItems={`center`}>
              <div>{displayLabel}</div>
              <AmountText>
                <Currency value={total} />
              </AmountText>
              <FlexRow>
                <SpaAddOutgoingButton
                  amount={total}
                  cdItemId={item.id}
                  onHideCDItem={onHide}
                  onAddTransaction={onAddTransaction}
                />
                <Button type={'button'} intent={'ghost'} isInline onClick={onHide}>
                  Hide
                </Button>
              </FlexRow>
            </Grid>
          </SpaceWrapper>
        </>
      )}
    </>
  );
};
